export default [
    {
        path: '/manufacturer/edit/:id',
        name: 'manufacturer_edit',
        component: () => import('@src/manufacturer/manufacturer.vue'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'Hersteller bearbeiten',
            role: 'ROLE_EDIT_MANUFACTURER',
        },
    },
    {
        path: '/manufacturer/create',
        name: 'manufacturer_create',
        component: () => import('@src/manufacturer/manufacturer.vue'),
        meta: {
            title: 'Hersteller erstellen',
            role: 'ROLE_EDIT_MANUFACTURER',
        },
    },
    {
        path: '/manufacturer/list/:filter?',
        name: 'manufacturer_list',
        component: () => import('@src/manufacturer/manufacturer-list'),
        meta: {
            title: 'Hersteller',
            role: 'ROLE_LIST_MANUFACTURER',
        },
    },
];
